import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { RequestOwnPasswordDTO } from '../model/users-model';
import { UsersApiService } from '../users-services/users-api.service';

@Component({
  selector: 'app-own-password',
  templateUrl: './own-password.component.html',
  styleUrls: ['./own-password.component.scss'],
})
export class OwnPasswordComponent implements OnInit {
  searchButtonDisabled: boolean = true;
  checkedWS: boolean = false;
  public ownPasswordForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private userService: UsersApiService,
    public dialog: MatDialog,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.ownPasswordForm = this.formBuilder.group({
      user: ['', Validators.required],
      password: ['', Validators.required],
      checkWebService: [false],
    });

    this.ownPasswordForm.statusChanges.subscribe(() => {
      if (this.ownPasswordForm.valid) {
        this.searchButtonDisabled = false;
      } else {
        this.searchButtonDisabled = true;
      }
    });
  }

  changePassword() {
    let dialogConfig = new MatDialogConfig();
    const request: RequestOwnPasswordDTO = {
      user: this.ownPasswordForm.controls.user.value,
      password: this.ownPasswordForm.controls.password.value,
      noExpires: this.ownPasswordForm.controls.checkWebService.value,
    };
    this.userService.postSetOwnPassword(request).subscribe(
      (password) => {
        //mostrar popup de confirmacion
        if (password) {
          dialogConfig.data = {
            text: this.translate.instant('ownPassword.passwordChanged'),
            icon: 'icon-ic_circle_check',
            noRedirect: true,
          };
        } else {
          dialogConfig.data = {
            text: this.translate.instant('ownPassword.passwordNotChanged'),
            icon: 'icon-ic_circle_cross',
            noRedirect: true,
          };
        }
        this.dialog.open(ResponseDialogComponent, dialogConfig);
      },
      (error) => {
        if (error.error.status === 400) {
          if (error.error.message.includes('User') && error.error.message.includes('does not exist')) {
            dialogConfig.data = {
              text: this.translate.instant('ownPassword.userNotExists'),
              icon: 'icon-ic_circle_cross',
              noRedirect: true,
            };
          } else if (
            error.error.message.includes(
              'The password must be 6 characters long and must contain letters, numbers, and special characters.'
            )
          ) {
            dialogConfig.data = {
              text: this.translate.instant('ownPassword.nonValidPassword'),
              icon: 'icon-ic_circle_cross',
              noRedirect: true,
            };
          }
        } else if (error.error.status === 500 && error.error.message.includes('PIN ALREADY USED PREVIOUSLY')) {
          dialogConfig.data = {
            text: this.translate.instant('ownPassword.usedPassword'),
            icon: 'icon-ic_circle_cross',
            noRedirect: true,
          };
        } else {
          dialogConfig.data = {
            text: this.translate.instant('ownPassword.unknown error'),
            icon: 'icon-ic_circle_cross',
            noRedirect: true,
          };
        }
        this.dialog.open(ResponseDialogComponent, dialogConfig);
      }
    );
  }
}
